var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.66667L17 8.33333V17L12.5455 15M12.5455 15L7.45455 17M12.5455 15V10.3333M7.45455 17L3 15V6.33333L6.18182 7.66667M7.45455 17V10.3333M10 13.182C10 13.182 6.18182 10 6.18182 7C6.18182 4.5 8.09091 3 10 3C11.9091 3 13.8182 4.5 13.8182 7C13.8182 10 10 13.182 10 13.182ZM10.6364 7C10.6364 6.82319 10.5693 6.65362 10.45 6.5286C10.3306 6.40357 10.1688 6.33333 10 6.33333C9.83123 6.33333 9.66936 6.40357 9.55002 6.5286C9.43068 6.65362 9.36364 6.82319 9.36364 7C9.36364 7.17681 9.43068 7.34638 9.55002 7.4714C9.66936 7.59643 9.83123 7.66667 10 7.66667C10.1688 7.66667 10.3306 7.59643 10.45 7.4714C10.5693 7.34638 10.6364 7.17681 10.6364 7Z",
    stroke: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.5b5cd97ef33f101ad8e19fda8b09beb5.svg";
export { ForwardRef as ReactComponent };